import router from '@bo/router';
import { BoAuthProvider } from '@boContexts/BoAuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PageLoading from '@sharedComponents/PageLoading';
import { ModalProvider } from '@sharedContexts/ModalContext';
import { SidebarProvider } from '@sharedContexts/SidebarContext';
import { init } from '@src/i18n';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { CONFIG_BO } from './config';

init(`${CONFIG_BO.BASE_URL}i18n`, ['common', 'bo']);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Suspense fallback={<PageLoading />}>
            <GoogleOAuthProvider clientId={CONFIG_BO.GOOGLE_CLIENT_ID}>
                <BoAuthProvider>
                    <ModalProvider>
                        <SidebarProvider>
                            <RouterProvider router={router} />
                        </SidebarProvider>
                    </ModalProvider>
                </BoAuthProvider>
            </GoogleOAuthProvider>
        </Suspense>
        <ToastContainer />
    </React.StrictMode>,
);
